import { FC, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks';
import { Input, Separator } from 'components/ui';
import { Container, RowParamBlock, Title } from './current-address.styled';

export const CurrentAddress: FC = observer(() => {
  const { createRequest, fias } = useStore();

  const currentAddress = useMemo(() => {
    const area =
      createRequest.applicant.applicantType === 'tenant'
        ? createRequest.selectedArea
        : null;

    const house = fias.addressesList.find(
      (address) => address.value === createRequest.requestData.house._id
    )?.label;

    return area
      ? `${area.house.address}, ${area.str_number_full}`
      : house || 'Неизвестный адрес';
  }, [
    createRequest.areas.length,
    createRequest.applicant.applicantType,
    createRequest.selectedArea,
    createRequest.requestData.area?._id,
    createRequest.requestData.house._id,
    fias.addressesList,
  ]);

  return (
    <Container>
      <RowParamBlock>
        <Title>Адрес</Title>
        <Input value={currentAddress} readOnly style={{ width: '100%' }} />
      </RowParamBlock>
      <Separator />
    </Container>
  );
});
